import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
	Box,

	Stack
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import MasterWeekViewV2 from "../DealMeetings/MasterWeekViewV2";


export default function AmbassadorDetailsStep3({ upperState }) {
	//console.log("AmbassadorDetailsStep3", upperState)
	const [complete, setComplete] = useState(false);
	const [state, setState] = useState({ init: false });
	const [loadingState, setLoadingState] = useState(false);

	const handleChange = (event) => {
		//console.log("handlechange", event);
		if (state.mode == "SETTINGS") {
			state.handleChange(event);
		} else {
			setState((state) => ({ ...state, [event.target.name]: event.target.value }));
		}

	};


	const setLocalUpperState = (obj) => {
		console.log("setLocalUpperState", obj, state.mode)
		if (state.mode == "SETTINGS") {
			state.setState((state) => ({ ...state, ambassador_slots_states: obj }));
		} else {
			setState({ ...state, ambassador_slots_states: obj });
		}
	};
	useEffect(() => {

		setState({ ...upperState, init: true });
		//setState({ ...upperState, ranges: upperState.ambassador_ranges_week.list, week: upperState.ambassador_ranges_week.week, init: true });

	}, []);

	const manageSubmit = () => {
		setLoadingState(true);
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(state),
		};

		fetch("/api/57daaf2602f64df1ad0da822a19cfcfc", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.href = "/devenir-ambassadeur/3";
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};

	if (!state.init) {
		return false;
	}
	useEffect(() => {

		var cplt = false;

		//	complete !== cplt ? setComplete(cplt) : null;
		console.log("ambassador_slots_states", state.ambassador_slots_states);
		//const asArray = );

		const filtered = Object.entries(state.ambassador_slots_states).filter(([key, value]) => value >= 2);


		console.log(filtered);
		setComplete(filtered.length > 0)
	}, [state]);


	// const handleFormat = (event, newFormats) => {
	// 	console.log("handleFormat", event, newFormats)
	// 	setState({ ...state, week: newFormats });
	// };



	return (

		<Stack spacing={1}>
			<Box display="flex" justifyContent="flex-end" alignItems="center" >
				<Box >
					{/* {state.mode == "ONBOARDING" && ( */}
					{
						true && (
							<LoadingButton
								loading={loadingState}
								onClick={manageSubmit}
								variant="contained"
								color="primary"
								disabled={!complete}>
								Valider
							</LoadingButton>
						)
					}
				</Box>
			</Box>
			<MasterWeekViewV2 state={state}
				setUpperState={setLocalUpperState}
			/>
			<Box display="flex" justifyContent="flex-end" alignItems="center" m={1}>
				<Box >
					{/* {state.mode == "ONBOARDING" && ( */}
					{
						true && (
							<LoadingButton loading={loadingState} onClick={manageSubmit} variant="contained" color="primary" disabled={!complete}>
								Valider
							</LoadingButton>
						)
					}
				</Box>
			</Box>
		</Stack>
	);
}




